import * as Icon from 'react-feather'

export default Icon
